<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.vin, 'VIN')"
      v-model="vin"
      :rules="vinValidationRules"
      @input="onInput"
      name="vin"
      variant="outlined"
      :tile="true"
      counter="17"
  >
    <template v-slot:append-inner>
      <v-tooltip
          location="top"
          open-delay="500"
          open-on-click open-on-hover
      >
        <template v-slot:activator="{ props }">
           <v-icon v-bind="props" class="cursor-pointer" aria-label="info">
            mdi-information
          </v-icon>
        </template>
        <span><NuxtImg
            src="/images/vehicle/registration_template/template_e.png"
            class="h-100"
            loading="lazy"
            alt="Registration template"
        /></span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const vin = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      vin.value = newValue;
    });

    watch(vin, (newValue) => {
      const valueToValidate = newValue || '';
      const isValid = validateVIN(valueToValidate);
      emit('update:modelValue', valueToValidate);
      emit('validation-vehicle-status', { field: 'vin', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const vinValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => (v && v.length === 17) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
      (v: string) => /^[A-HJ-NPR-Z0-9]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateVIN(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = vinValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return vinValidationRules.every(rule => rule(value) === true);
    }

    const onInput = function (event: Event) {
      const input = event.target as HTMLInputElement;
      vin.value = input.value.toUpperCase();
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'vin') {
          error.value = [];
          const isValid = validateVIN(vin.value, true);
          emit('validation-vehicle-status', { field: 'vin', isValid });
        }
      });
    });

    return {
      vin,
      vinValidationRules,
      translationList,
      translation,
      onInput,
      error,
    };
  },
});
</script>

<style scoped>
</style>